import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';

/*
  Generated class for the ChilanNews page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-ChilanNews',
    templateUrl: 'ChilanNews.html'
})
export class ChilanNewsPage {

    public a_News: any = [];
    constructor(public navCtrl: NavController, public serviceProvider: ServiceProvider, public navParams: NavParams) { }

    ionViewDidLoad() {
        this.serviceProvider.Get('/ispa_chLastNewsList', false).then((result: any) => {
            result.forEach((value, index) => {
                let item = {
                    Title: '',
                    Date: '',
                    Image: '',
                    Desc: ''
                };
                item.Title = value.cdValue1_txt;
                item.Date = value.cdValue2_txt;
                for (var i = 0; i < value.DetailedForm.length; i++) {
                    if (value.DetailedForm[i].tODataDetailId == 10186) {
                        item.Image = value.DetailedForm[i].cddValue_txt
                    }
                    else if (value.DetailedForm[i].tODataDetailId == 10187) {
                        item.Desc = value.DetailedForm[i].cddValue_txt;
                    }
                }
                this.a_News.push(item);
            });

        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/chilan/ChilanNews/ChilanNews.ts